import React from "react";
import getSize from "../../../utils/getSize";
import css from './index.css';
import XsbdqktjTable from './tjTable/bdqktjTable';

/**
 * 报到情况统计
 * @author huanghaoyu
 * @date 2018-07-03 15:45:03
 * Version: 1.0
 */
class BdqktjTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }

    render() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'RN',
                width: '50px',
            }, {
                title: '到校日期',
                width: '100px',
                dataIndex: 'DXRQ',
                searchType:"date"
            }, {
                title: '交通工具',
                dataIndex: 'JTGJ',
                width: '100px',
                searchType:"input"
            }, {
                title: '到达站',
                dataIndex: 'DDZ',
                width: '100px',
                searchType:"input"
            }, {
                title: '00:00-06:00',
                dataIndex: 'LC',
                width: '100px',
                commonSearch : false,
            }, {
                title: '06:00-12:00',
                width: '100px',
                dataIndex: 'ZS',
                commonSearch : false,
            }, {
                title: '12:00-18:00',
                width: '100px',
                dataIndex: 'XW',
                commonSearch : false,
            }, {
                title: '18:00-24:00',
                width: '100px',
                dataIndex: 'WS',
                commonSearch : false,
            }
        ];
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 230 }}>
                <div style={{ width: '100%', height: '100%', }}>
                    <XsbdqktjTable ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_bdqktj_queryPage"}
                        columns={columnConst}
                    >
                    </XsbdqktjTable>

                </div>
            </div>
        )
    }
}
export default BdqktjTab;



// WEBPACK FOOTER //
// ./components/tjcx/bdqkcx/bdqktjTab.js